import React, {Component} from 'react'

class TableHead extends Component {
    render() {
        return (
            <thead>
            <tr>
                <th>#</th>
                <th>Barcode</th>
                <th>Lô</th>
                <th>Trạng thái</th>
                <th>Size</th>
                <th>Type</th>
            </tr>
            </thead>
        )
    }
}

export default TableHead